let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("drHCA")).then(() => parcelRequire('5VIEE'));